/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'sarsaparilla';
import isEqual from 'lodash/isEqual';
import CommercialGuideItem from './CommercialGuideItem';

const blankGuide = {
    first_name: '',
    last_name: '',
    license_number: '',
    license_expiration_date: '',
    employee_id: '',
};

export default class CommercialGuideList extends React.Component {
    constructor(props) {
        super(props);

        this.addGuide = this.addGuide.bind(this);
        this.handleGuideChange = this.handleGuideChange.bind(this);
        this.handleGuideRemove = this.handleGuideRemove.bind(this);
        this.state = {
            guides: props.guides.length === 0 ? [blankGuide] : props.guides,
        };
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.guides, this.props.guides)) {
            this.setState({
                guides: this.props.guides.length === 0 ? [blankGuide] : this.props.guides,
            });
        }
    }

    addGuide() {
        if (this.state.guides.length >= this.props.maxGuideQuota) {
            return;
        }
        const newGuides = Object.assign([], this.state.guides);
        newGuides.push(blankGuide);
        this.setState({ guides: newGuides });
        this.props.handleGuidesChange(newGuides);
    }

    handleGuideChange(index, guide) {
        const newGuides = Object.assign([], this.state.guides, { [index]: guide });
        this.props.handleGuidesChange(newGuides, false);
    }

    handleGuideRemove(index) {
        const newGuides = Object.assign([], this.state.guides);
        newGuides.splice(index, 1);
        this.props.handleGuidesChange(newGuides);
    }

    renderList() {
        const guides = Object.assign([], this.state.guides);
        return guides.map((guide, index) => (
            <CommercialGuideItem
                key={index}
                index={index}
                guide={guide}
                allGuides={this.props.allGuides}
                handleGuideChange={this.handleGuideChange}
                handleGuideRemove={this.handleGuideRemove}
                disableRemove={this.props.disableListSizeChange}
                isDisabled={this.props.isDisabled}
            />
        ));
    }

    renderAddGuideButton() {
        return (
            !this.props.disableListSizeChange && (
                <div className="rec-form-item-wrap">
                    <Button
                        appearance="link"
                        iconBeforeElement={<Icon iconName="add-circle" />}
                        onClick={this.addGuide}
                        className="addOneGuideLink"
                    >
                        Add another employee or guide
                    </Button>
                </div>
            )
        );
    }

    render() {
        return (
            <div className="per-commercial-guides-form per-section-group">
                <div className="rec-order-detail-subsection-title">
                    Employees and Guides
                </div>
                <p>Please list all guides that will be going on this trip.</p>
                <div className="per-form-group">{this.renderList()}</div>
                {this.renderAddGuideButton()}
            </div>
        );
    }
}

CommercialGuideList.propTypes = {
    guides: PropTypes.arrayOf(PropTypes.shape({})),
    allGuides: PropTypes.array.isRequired,
    maxGuideQuota: PropTypes.number,
    handleGuidesChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    disableListSizeChange: PropTypes.bool,
};

CommercialGuideList.defaultProps = {
    maxGuideQuota: 50,
    guides: [],
    disableListSizeChange: false,
};
